module.exports = __webpack_public_path__ + "static/img/5.9bb0421.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/5.png
// module id = VDeq
// module chunks = 0